import React, { useContext, createContext } from 'react';
import useWishLists from './use';

const WishListsContext = createContext({});
const useWishListsContext = () => useContext(WishListsContext);

const WishListsContextProvider = ({ children }) => {
    const wishLists = useWishLists();

    return (
        <WishListsContext.Provider value={wishLists}>
            {children}
        </WishListsContext.Provider>
    );
};

export { useWishListsContext };

export default WishListsContextProvider;
